import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=328077ed&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=ts"
export * from "./Attachment.vue?vue&type=script&lang=ts"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=328077ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328077ed",
  null
  
)

export default component.exports